/**
 * Utility class for handling number formatting
 */
export const formatBalance = (balance) => {
  let typeCheckedBalance = Number(balance);
  let prefix = '$';
  if (typeCheckedBalance < 0) {
    prefix = '-$';
    typeCheckedBalance = Math.abs(typeCheckedBalance);
  }
  return prefix.concat(typeCheckedBalance.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'));
};

export const formatPercentage = (percentage) => {
  const typeCheckedPercentage = Number(percentage);
  if (typeCheckedPercentage && !Number.isNaN(typeCheckedPercentage)) {
    return (typeCheckedPercentage.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')).concat('%');
  }
  return '0.00%';
};

export const formatPercentageRounded = (percentage) => {
  const typeCheckedPercentage = Number(percentage);
  if (typeCheckedPercentage && !Number.isNaN(typeCheckedPercentage)) {
    return (typeCheckedPercentage.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')).concat('%');
  }
  return '0%';
};

export const padLeadingZero = (number) => {
  if (number && number.toString().length === 1) {
    return '0'.concat(number);
  }
  return number ? number.toString() : number;
};

export const formatBalanceNoFixed = (balance) => {
  let typeCheckedBalance = Number(balance);
  let prefix = '$';
  if (typeCheckedBalance < 0) {
    prefix = '-$';
    typeCheckedBalance = Math.abs(typeCheckedBalance);
  }
  return prefix.concat(String(typeCheckedBalance).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'));
};

export const formatNumberAsDigits = (inputNum) => {
  return inputNum.split('').join(' ');
};

export const convertForAccessibility = (value) => {
  return (value && value.startsWith('-')) ? 'minus '.concat(value.substring(1)) : value;
};



// WEBPACK FOOTER //
// ./services/NumberFormatters.js